import {
  IDV360TicketsLineItem,
  IDuplicateDV360TicketsLineItemPayload,
} from '@/Interfaces/DV360Tickets/LineItem.interface';
import { DV360_TICKETS_LINE_ITEMS_ENDPOINT } from '@/constants/endpoints';
import axios from 'axios';

export const duplicateDV360TicketsLineItem = async (
  id: number,
  data: IDuplicateDV360TicketsLineItemPayload,
): Promise<IDV360TicketsLineItem> => {
  const res = await axios.post(`${DV360_TICKETS_LINE_ITEMS_ENDPOINT}/${id}/duplicate`, data);
  return res.data;
};
